var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{attrs:{"type":"primary","size":"sm"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-arrow-left fa-fw"}),_vm._v("Volver\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }